








































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { getLocale } from '@/utils/utils'
import enseedEditor from './components/EnSEEDEditor.vue'
import eyfsEditor from './components/EYFSEditor.vue'
import fiveEditor from './components/FiveEditor.vue'
import { DropDownController, GradeFrameController } from '@/services/request.service'

@Component({
  components: {
    enseedEditor,
    eyfsEditor,
    fiveEditor,
  },
})
export default class AddAssessmentSheet extends Vue {
  @Prop()
  private readonly gradeFrameId!: number
  @Prop()
  private readonly schoolYear!: string

  private loading = false
  private canLeave = false
  private gradeTableId = 0
  private assessmentSheet = {
    name: null,
    sectionId: [],
  }
  private subjects: Array<any> = []
  private sections: Array<any> = []
  private saved = false
  private gradings: Array<any> = []
  private frameType = ''

  private get rules(): any {
    return {
      name: [
        {
          required: true,
          message: this.$tc('assessmentFrame.enterSheetName'),
          trigger: 'change',
        },
        {
          max: 200,
          message: this.$tc('assessmentFrame.sheetNameLimit'),
          trigger: 'change',
        },
      ],
      sectionId: [
        {
          required: true,
          message: this.$tc('assessmentFrame.selectSection'),
          trigger: 'change',
        },
      ],
    }
  }

  private get locale(): string {
    return getLocale() || 'zh'
  }

  private created(): void {
    this.getSections()
    this.getFrames()
  }

  private getFrames(): void {
    GradeFrameController.getGradeFrameList()
      .then(res => {
        this.frameType = res.data.gradeFrameList.filter(
          frame => frame.gradeFrameId === this.gradeFrameId
        )[0].type
      })
      .catch(err => {
        console.error(err)
      })
  }

  private getSections(): void {
    DropDownController.getSectionBases()
      .then(res => {
        this.sections = res.data
      })
      .catch(err => {
        console.error(err)
      })
  }

  private saveTable(): void {
    this.loading = true
    const { gradeFrameId } = this
    const assessmentSheet = this.$refs.assessmentSheet as any
    assessmentSheet.validate(valid => {
      if (valid) {
        const { name, sectionId } = this.assessmentSheet
        const request = {
          gradeFrameId,
          gradeTableId: this.gradeTableId || undefined,
          name,
          sectionId,
        } as any
        GradeFrameController.saveGradeTable(request)
          .then(res => {
            this.gradeTableId = res.data
            this.canLeave = true
            this.saved = true
            this.$message.success(this.$tc('common.saveSuccess'))
            this.getGradings()
          })
          .catch(err => {
            console.error(err)
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        this.loading = false
        return false
      }
    })
  }

  private getGradings(): void {
    const { gradeTableId, schoolYear } = this
    GradeFrameController.getGradeTableStructure(gradeTableId, schoolYear)
      .then(res => {
        this.$set(this.assessmentSheet, 'name', res.data.name)
        this.$set(
          this.assessmentSheet,
          'sectionId',
          res.data.targetSections?.map(item => item.sectionId) ?? undefined
        )
        this.gradings = res.data.gradeClasses
        this.frameType = res.data.gradeFrame?.type
      })
      .catch(err => {
        console.error(err)
      })
  }

  private saveLevelA(levelA): void {
    const { abbreviation, name } = levelA
    GradeFrameController.addGradeClass({
      abbreviation,
      name,
      gradeClassId: undefined,
      gradeTableId: this.gradeTableId,
      rank: 1,
    })
      .then(res => {
        this.getGradings()
      })
      .catch(err => {
        console.error(err)
      })
  }

  private saveLevelB(payload): void {
    const { parentNumber, levelB } = payload
    const { abbreviation, name } = levelB
    GradeFrameController.addGradeClass({
      abbreviation,
      name,
      gradeClassId: undefined,
      parentNumber,
      gradeTableId: this.gradeTableId,
      rank: 2,
      gradingStandards:
        this.frameType === '1311'
          ? [
              {
                description: levelB.emerging1,
              },
              {
                description: levelB.emerging2,
              },
              {
                description: levelB.emerging3,
              },
              {
                description: levelB.performing4,
              },
              {
                description: levelB.performing5,
              },
              {
                description: levelB.performing6,
              },
              {
                description: levelB.mastering7,
              },
              {
                description: levelB.mastering8,
              },
              {
                description: levelB.mastering9,
              },
            ]
          : undefined,
    })
      .then(res => {
        this.getGradings()
      })
      .catch(err => {
        console.error(err)
      })
  }

  private saveLevelC(payload): void {
    const { parentNumber, levelC } = payload
    const { abbreviation, name } = levelC
    GradeFrameController.addGradeClass({
      abbreviation,
      name,
      gradeClassId: undefined,
      parentNumber,
      gradeTableId: this.gradeTableId,
      rank: 3,
      gradingStandards: [
        {
          description: levelC.emerging,
        },
        {
          description: levelC.performing,
        },
        {
          description: levelC.mastering,
        },
      ],
    })
      .then(res => {
        this.getGradings()
      })
      .catch(err => {
        console.error(err)
      })
  }

  private removeLeveA(gradeClassId): void {
    GradeFrameController.deleteGradeClass(gradeClassId, this.gradeTableId)
      .then(res => {
        this.gradings = this.gradings.filter(levelA => levelA.gradeClassId !== gradeClassId)
      })
      .catch(err => {
        console.error(err)
      })
  }

  private removeLevelB(gradeClassId): void {
    GradeFrameController.deleteGradeClass(gradeClassId, this.gradeTableId)
      .then(res => {
        this.getGradings()
      })
      .catch(err => {
        console.error(err)
      })
  }

  private removeLevelC(gradeClassId): void {
    GradeFrameController.deleteGradeClass(gradeClassId, this.gradeTableId)
      .then(res => {
        this.getGradings()
      })
      .catch(err => {
        console.error(err)
      })
  }

  private updateLevelA(newLevelA): void {
    GradeFrameController.updateGradeClass({
      ...newLevelA,
      gradeTableId: this.gradeTableId,
    })
      .then(res => {
        this.getGradings()
      })
      .catch(err => {
        console.error(err)
      })
  }

  private updateLevelB(levelB): void {
    const { abbreviation, name } = levelB
    GradeFrameController.updateGradeClass({
      abbreviation,
      name,
      gradeClassId: levelB.gradeClassId,
      gradeTableId: this.gradeTableId,
      rank: 2,
      gradingStandards:
        this.frameType === '1311'
          ? [
              {
                gradeLevelId: levelB.emerging1Id,
                description: levelB.emerging1,
              },
              {
                gradeLevelId: levelB.emerging2Id,
                description: levelB.emerging2,
              },
              {
                gradeLevelId: levelB.emerging3Id,
                description: levelB.emerging3,
              },
              {
                gradeLevelId: levelB.performing4Id,
                description: levelB.performing4,
              },
              {
                gradeLevelId: levelB.performing5Id,
                description: levelB.performing5,
              },
              {
                gradeLevelId: levelB.performing6Id,
                description: levelB.performing6,
              },
              {
                gradeLevelId: levelB.mastering7Id,
                description: levelB.mastering7,
              },
              {
                gradeLevelId: levelB.mastering8Id,
                description: levelB.mastering8,
              },
              {
                gradeLevelId: levelB.mastering9Id,
                description: levelB.mastering9,
              },
            ]
          : undefined,
    })
      .then(res => {
        this.getGradings()
      })
      .catch(err => {
        console.error(err)
      })
  }

  private updateLevelC(levelC): void {
    const { abbreviation, name } = levelC
    GradeFrameController.updateGradeClass({
      abbreviation,
      name,
      gradeClassId: levelC.gradeClassId,
      gradeTableId: this.gradeTableId,
      rank: 3,
      gradingStandards: [
        {
          gradeLevelId: levelC.emergingId,
          description: levelC.emerging,
        },
        {
          gradeLevelId: levelC.performingId,
          description: levelC.performing,
        },
        {
          gradeLevelId: levelC.masteringId,
          description: levelC.mastering,
        },
      ],
    })
      .then(res => {
        this.getGradings()
      })
      .catch(err => {
        console.error(err)
      })
  }

  private back(): void {
    this.$router.back()
  }
}
